import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/8577643/pexels-photo-8577643.jpeg?auto=compress&cs=tinysrgb&w=1800";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative water-gradient grain overflow-hidden border-b border-rule"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 pt-12 md:pt-20 pb-14 md:pb-24 grid grid-cols-12 gap-6 md:gap-10 items-end">
        <div className="col-span-12 md:col-span-6 lg:col-span-5">
          <div className="flex items-center gap-3 mb-7 md:mb-10 reveal">
            <span className="h-px w-8 md:w-10 bg-ink/40" />
            <span className="overline text-[10px] md:text-xs text-ink/60">Cascais / Oeiras / Sintra / Lisboa</span>
          </div>

          <h1 className="font-serif font-light text-[2.6rem] leading-[1.04] sm:text-6xl lg:text-7xl tracking-tight text-ink reveal">
            Veja o seu
            <span className="italic text-pool-deep"> jardim </span>
            antes de{" "}
            <br className="hidden md:block" />
            investir numa
            <span className="italic"> piscina.</span>
          </h1>

          <p className="mt-6 md:mt-10 max-w-md text-base md:text-lg leading-relaxed text-ink/70 font-light reveal">
            Envie uma fotografia do seu jardim. Devolvemos uma simulação fotorrealista, uma estimativa de investimento honesta e a ligação ao instalador certo para a sua zona. Sem compromisso.
          </p>

          <div className="mt-8 md:mt-12 flex flex-col sm:flex-row gap-4 sm:gap-8 items-stretch sm:items-center reveal">
            <a href="#pedido" className="btn-primary justify-center" data-testid="hero-cta-primary">
              Começar simulação
              <ArrowRight size={16} strokeWidth={1.5} />
            </a>
            <a href="#processo" className="btn-ghost self-start sm:self-auto" data-testid="hero-cta-secondary">
              Como funciona
            </a>
          </div>

          <dl className="mt-12 md:mt-16 grid grid-cols-3 gap-4 md:gap-6 max-w-md reveal">
            <div>
              <dt className="overline text-[10px] text-ink/50">Resposta</dt>
              <dd className="font-serif text-xl md:text-3xl mt-2">{"<"}24h</dd>
            </div>
            <div>
              <dt className="overline text-[10px] text-ink/50">Custo</dt>
              <dd className="font-serif text-xl md:text-3xl mt-2">Sem custo</dd>
            </div>
            <div>
              <dt className="overline text-[10px] text-ink/50">Zona</dt>
              <dd className="font-serif text-xl md:text-3xl mt-2">Linha</dd>
            </div>
          </dl>
        </div>

        <div className="col-span-12 md:col-span-6 lg:col-span-7 relative">
          <div className="relative aspect-[4/5] md:aspect-[5/6] overflow-hidden reveal-image">
            <img
              src={HERO_IMG}
              alt="Jardim residencial com piscina"
              className="w-full h-full object-cover"
              data-testid="hero-image"
            />
            <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6 flex items-end justify-between text-paper">
              <div>
                <div className="overline text-[10px] md:text-xs opacity-80">Residência privada</div>
                <div className="font-serif text-lg md:text-2xl mt-1 italic">Simulação em moradia típica</div>
              </div>
              <div className="overline text-[10px] md:text-xs opacity-80">Ref. 001</div>
            </div>
          </div>
          <div className="absolute -top-6 -left-6 hidden md:block overline text-ink/50 rotate-[-90deg] origin-top-left">
            Estúdio de visualização residencial
          </div>
        </div>
      </div>
    </section>
  );
}
